import { SortType } from '@/models/SortType';
import { HistoriqueReclamation, SuiviReclamation } from '@/models/SuiviReclamation';
import { TableHeader } from '@/models/TableHeader';
import { MutationTree } from 'vuex';
import { SUIVI_RECLAMATION } from './mutation-types';
import { initialState as resetState, SuiviReclamationState } from './state';

export const mutations: MutationTree<SuiviReclamationState> = {
    [SUIVI_RECLAMATION.SET_ITEMS](state, items: SuiviReclamation[]) {
        state.reclamations = items;
    },
    [SUIVI_RECLAMATION.RESET_ITEMS](state) {
        state.reclamations = [];
        state.page = 0;
        state.count = 0;
    },
    [SUIVI_RECLAMATION.ADD_ITEMS](state, items: SuiviReclamation[]) {
        state.reclamations = [...state.reclamations, ...items];
    },
    [SUIVI_RECLAMATION.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [SUIVI_RECLAMATION.SET_NB_OF_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },
    [SUIVI_RECLAMATION.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [SUIVI_RECLAMATION.SET_COUNT](state, count: number) {
        state.count = count;
    },
    [SUIVI_RECLAMATION.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [SUIVI_RECLAMATION.ADD_FILTER_SITE](state, site: number) {
        state.filterSite = [...state.filterSite, site];
    },
    [SUIVI_RECLAMATION.REMOVE_FILTER_SITE](state, site: number) {
        state.filterSite = state.filterSite.filter(x => x !== site);
    },
    [SUIVI_RECLAMATION.SET_FILTER_SITE](state, siteList: number[]) {
        state.filterSite = siteList;
    },
    [SUIVI_RECLAMATION.ADD_FILTER_STATUS](state, status: string) {
        state.filterStatus = [...state.filterStatus, status];
    },
    [SUIVI_RECLAMATION.REMOVE_FILTER_STATUS](state, status: string) {
        state.filterStatus = state.filterStatus.filter(x => x !== status);
    },
    [SUIVI_RECLAMATION.SET_FILTER_STATUS](state, statusList: string[]) {
        state.filterStatus = statusList;
    },
    [SUIVI_RECLAMATION.SET_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [SUIVI_RECLAMATION.SET_ERROR](state, error: Error) {
        state.error = error;
    },
    [SUIVI_RECLAMATION.SET_HISTORIQUE](state, items: HistoriqueReclamation[]) {
        state.historiques = items;
    },
    [SUIVI_RECLAMATION.ADD_HISTORIQUE_ITEM](state, item: HistoriqueReclamation) {
        state.historiques.push(item);
    },
    [SUIVI_RECLAMATION.RESET](state){
        Object.assign(state, resetState);
    },
    [SUIVI_RECLAMATION.SET_EXPORT_RECLAMATION_IS_LOADING](state, isLoading: boolean){
        state.isExportLoading = isLoading;
    }
};
